export default [
  {
    path: '/reports',
    name: 'report',
    meta: {
      breadcrumb: [
        { text: 'report.title', active: true },
      ],
      pageTitle: 'report.title',
      roles: ['ROLE_DATA_ANALYST', 'ROLE_HR_MANAGER', 'ROLE_ADVANCED_DISPATCHER'],
    },
    component: () => import('@/views/reports/ReportView'),
  },
]
